module.exports = __webpack_public_path__ + "img/payment-method.1f0b0dbf.svg";